import styled from 'styled-components'

export const TableScroll = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  table {
    min-width: 640px;
  }
`

export const CustomTd = styled.td`
  display: table-cell;
  vertical-align: middle;
  max-width: none;
  word-break: break-word;
  overflow-wrap: break-word;
  padding: 10px 12px;
  font-size: 14px;

  @media (max-width: 1199px) {
    padding: 8px 10px;
    font-size: 13px;
  }

  @media (max-width: 991px) {
    padding: 7px 8px;
    font-size: 12px;
  }

  @media (max-width: 767px) {
    padding: 6px 8px;
    font-size: 12px;
  }

  @media (max-width: 576px) {
    padding: 8px 10px;
    font-size: 12px;
  }
`

export const TitleContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const HeaderText = styled.th`
  padding: 10px 12px;
  font-size: 14px;
  white-space: nowrap;

  @media (max-width: 1199px) {
    padding: 8px 10px;
    font-size: 13px;
  }

  @media (max-width: 991px) {
    padding: 7px 8px;
    font-size: 12px;
  }

  @media (max-width: 767px) {
    padding: 6px 8px;
    font-size: 12px;
  }

  @media (max-width: 576px) {
    padding: 8px 10px;
    font-size: 12px;
    white-space: nowrap;
  }
`

export const CaptionText = styled.caption`
  caption-side: bottom;
  text-align: left;
  font-style: italic;
  margin-top: 10px;
`
